import React, { useState } from "react";
import { IErgebnis } from "../../util/types";
import { BlobProvider } from "@react-pdf/renderer";
import { UrkundePdf } from "../UrkundePdf";

type MyProps = {
  id: number;
};

const UrkundenDialogButton: React.FC<MyProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<IErgebnis[]>([]);

  React.useEffect(() => {
    if (!isOpen) return;

    fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restGetUrkundenQueryById.rest?id=" + props.id)
      .then(response => response.json())
      .then(setData)
      .catch((e) => console.log(e));
  }, [isOpen]);

  const getMsToTime = (microseconds: number) => {
    let sekunden = Math.floor(microseconds / 1000000);
    let rest = sekunden;
    let stunden = Math.floor(rest / 3600);
    rest = rest % 3600;
    let minuten = Math.floor(rest / 60);
    sekunden = rest % 60;

    let strstunden = "" + stunden;
    let strminuten = "" + minuten;
    let strsekunden = "" + sekunden;

    if (stunden <= 9)
      strstunden = "0" + strstunden;
    if (minuten <= 9)
      strminuten = "0" + strminuten;
    if (sekunden <= 9)
      strsekunden = "0" + strsekunden;

    return `${strstunden}:${strminuten}:${strsekunden}`;
  }

  function isKinderUrkunde(ergebnis: IErgebnis) {
    return ergebnis.distanzMeter < 1000 && ergebnis.disziplin.toLowerCase().startsWith("u");
  }

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Urkunde
      </button>

      {isOpen && (
        <div style={overlayStyle}>
          <div style={dialogStyle}>
            <button
              onClick={() => setIsOpen(false)}
              style={closeButtonStyle}
            >
              ✕
            </button>

            {data.map((ergebnis, index) => (
              <div key={index} className="p-4 mb-4 rounded flex gap-4">
                <div className="flex-1">
                  <p><strong>Name:</strong> {ergebnis.name}</p>
                  <p><strong>Kategorie:</strong> {ergebnis.disziplin}</p>
                  <p><strong>Zeit:</strong> {getMsToTime(ergebnis.ms)}</p>
                  <p><strong>Platz:</strong> {ergebnis.ranglistenPlatz}</p>
                </div>
                <div className="flex-shrink-0">
                  <BlobProvider
                    document={
                      <UrkundePdf ergebnis={ergebnis} mitPlatzierung={false} />
                    }
                  >
                    {({ loading, blob, url, error }: { loading: boolean; blob: Blob | null; url: string | null; error: Error | null }) => (
                      <button className="btn btn-success" disabled={loading} onClick={() => url && window.open(url, '_blank')}>
                        {loading ? 'Wird generiert...' : 'Urkunde ohne Platzierung'}
                      </button>
                    )}
                  </BlobProvider>

                  <br />
                  <br />

                  {!isKinderUrkunde(ergebnis) && (
                    <BlobProvider
                      document={
                        <UrkundePdf ergebnis={ergebnis} mitPlatzierung={true} />
                      }
                    >
                      {({ loading, blob, url, error }: { loading: boolean; blob: Blob | null; url: string | null; error: Error | null }) => (
                        <button className="btn btn-success" disabled={loading} onClick={() => url && window.open(url, '_blank')}>
                          {loading ? 'Wird generiert...' : 'Urkunde mit Platzierung'}
                        </button>
                      )}
                    </BlobProvider>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const dialogStyle: React.CSSProperties = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  minWidth: "400px",
  minHeight: "200px",
  position: "relative",
};

const closeButtonStyle: React.CSSProperties = {
  position: "absolute",
  top: "10px",
  right: "10px",
};

export default UrkundenDialogButton;